import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from "../../config/Base_Url_Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SignUp = () => {
      const navigate = useNavigate();
      const [showPassword, setShowPassword] = useState(false);
      const [termsChecked, setTermsChecked] = useState(false);
      const [showConfirmPassword, setShowConfirmPassword] = useState(false);
      const [formData, setFormData] = useState({
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            term:"",
            // agreement:""
      });

      const [loading, setLoading] = useState(false);
      const [error, setError] = useState("");
      const [success, setSuccess] = useState("");

      // Handle input change
      const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({
                  ...formData,
                  [name]: value
            });
      };

      // Handle form submission
      const handleSubmit = async (e) => {
            e.preventDefault();
            setLoading(true);
            setError("");
            setSuccess("");

            if (formData.password !== formData.password_confirmation) {
                  setError("Passwords do not match!");
                  setLoading(false);
                  return;
            }
            if (formData.password.length < 8) {
                  setError("The password field must be at least 8 characters.")
                  setLoading(false);
                  return;
            }

            // Create FormData object
            const formDataToSend = new FormData();
            formDataToSend.append("name", formData.name);
            formDataToSend.append("email", formData.email);
            formDataToSend.append("password", formData.password);
            formDataToSend.append("password_confirmation", formData.password_confirmation);
            formDataToSend.append("term", formData.term);
            // formDataToSend.append("agreement", formData.agreement);

            try {
                  const response = await fetch(`${API_BASE_URL}/web-user-register`, {
                        method: "POST",
                        body: formDataToSend, // Send FormData instead of JSON
                  });
                  const result = await response.json();
                  // if(result?.email[0]){
                  //       setError("The email has already been taken")
                  // }
                  if (result.token) {
                        localStorage.setItem("token", result?.token)
                        localStorage.setItem("user", JSON.stringify(result?.user))
                        setSuccess("Signup successful! Redirecting...");
                        localStorage.setItem("is_user_active", true)
                        setFormData({ name: "", email: "", password: "", password_confirmation: "" });
                        toast.success("Register Successful !")
                        navigate("/home");
                  }
                   else {
                        setError(result.message || "The email has already been taken");
                  }
            } catch (error) {
                  setError("Something went wrong. Please try again.");
            } finally {
                  setLoading(false);
            }
      };

      const handleCheckboxChange = (type, checked) => {
            // if (type === "terms") {
            // setTermsChecked(checked);
            // } 
            // else if (type === "agreement") {
            // setAgreementChecked(checked);
            // }
            // if (!checked || (!termsChecked && type === "agreement") || (!agreementChecked && type === "terms")) {
            // setError("Please accept both the Terms & Policies and the Passport Account Agreement.");
            // } else {
            // setError(null);
            // }
              if (type === "terms") {
                  setTermsChecked(checked);
                  if (!checked) {
                        setError("Please accept the Terms & Condition");
                  } else {
                        setError("");
                  }
             }
      };


      return (
            <>
                  <Header />
                  {/* <-------- ToastContainer ------------> */}
                  <ToastContainer style={{ marginTop: "120px" }} />
                  <section className="relative overflow-hidden py-10 md:py-24">
                        <div className="absolute inset-0 -z-10 bg-[#111315]"></div>
                        <div className="absolute inset-0 -z-10 theme-hero-bg"></div>
                        <div className="absolute inset-0 -z-10 theme-grid-overlay" />
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                              <div className="flex flex-col items-center justify-center">
                                    <div className="w-full rounded-xl border border-amber-500/20 bg-[#252b33]/95 shadow-2xl backdrop-blur-xl sm:max-w-md">
                                          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                                <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl">
                                                      Sign Up to your account
                                                </h1>

                                                {/* {error && <div className="text-red-500 text-sm font-medium">{error}</div>} */}
                                                {success && <div className="text-amber-500 text-sm font-medium">{success}</div>}

                                                <form className="space-y-4" onSubmit={handleSubmit}>
                                                      {/* Name Field */}
                                                      <div>
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Your Name
                                                            </label>
                                                            <input
                                                                  type="text"
                                                                  name="name"
                                                                  className="theme-input"
                                                                  placeholder="Your full name"
                                                                  required
                                                                  value={formData.name}
                                                                  onChange={handleChange}
                                                            />
                                                      </div>

                                                      {/* Email Field */}
                                                      <div>
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Your Email ID
                                                            </label>
                                                            <input
                                                                  type="email"
                                                                  name="email"
                                                                  className="theme-input"
                                                                  placeholder="name@company.com"
                                                                  required
                                                                  value={formData.email}
                                                                  onChange={handleChange}
                                                            />
                                                      </div>

                                                      {/* Password Field */}
                                                      <div className="relative mb-4">
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Password
                                                            </label>
                                                            <input
                                                                  type={showPassword ? "text" : "password"}
                                                                  name="password"
                                                                  className="theme-input pr-10"
                                                                  placeholder="••••••••"
                                                                  required
                                                                  value={formData.password}
                                                                  onChange={handleChange}
                                                            />
                                                            <span
                                                                  className="absolute right-3 top-[38px] cursor-pointer text-stone-300"
                                                                  onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                      </div>

                                                      {/* Confirm Password Field */}
                                                      <div className="relative mb-4">
                                                            <label className="block mb-2 text-sm font-medium text-stone-200">
                                                                  Confirm Password
                                                            </label>
                                                            <input
                                                                  type={showConfirmPassword ? "text" : "password"}
                                                                  name="password_confirmation"
                                                                  className="theme-input pr-10"
                                                                  placeholder="••••••••"
                                                                  required
                                                                  value={formData.password_confirmation}
                                                                  onChange={handleChange}
                                                            />
                                                            <span
                                                                  className="absolute right-3 top-[38px] cursor-pointer text-stone-300"
                                                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            >
                                                                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                      </div>

                                                      <div className="flex items-center justify-between">
                                                           <label className="flex items-start gap-2 text-sm text-stone-300">
                                                            <input
                                                                  type="checkbox"
                                                                  name="term"
                                                                  className="h-4 w-4 rounded border border-amber-400/40 bg-transparent"
                                                                  checked={termsChecked}
                                                                  onChange={(e) => handleCheckboxChange("terms", e.target.checked)}
                                                                  required
                                                                  value={formData.term}
                                                            />
                                                            <span>
                                                                  I accept the{" "}
                                                                  <Link
                                                                        to="/privacy-policy"
                                                                        className="text-amber-600 underline hover:text-amber-800"
                                                                        target="_blank"
                                                                  >
                                                                        Terms & Policies
                                                                  </Link>
                                                            </span>
                                                            </label> 
                                                      </div>


                                                      {/* <div className="flex items-center justify-between">
                                                           <label className="flex items-start gap-2 text-sm text-gray-700">
                                                            <input
                                                                  type="checkbox"
                                                                  name="agreement"
                                                                  className="w-4 h-4 border border-gray-300 rounded"
                                                                  checked={agreementChecked}
                                                                  onChange={(e) => handleCheckboxChange("agreement", e.target.checked)}
                                                                  required
                                                                  value={formData.agreement}
                                                            />
                                                            <span>
                                                                  I accept the{" "}
                                                                  <Link
                                                                        to="/agreement"
                                                                        className="text-amber-600 underline hover:text-amber-800"
                                                                         target="_blank"
                                                                        
                                                                  >
                                                                        Passport Account Agreement
                                                                  </Link>
                                                            </span>
                                                            </label> 
                                                      </div> */}

                                                      

                                                      {/* Submit Button */}
                                                      {/* <button
                                                            type="submit"
                                                            className="w-full text-white bg-stone-1000 hover:bg-amber-600 focus:ring-2 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                            disabled={loading}
                                                      >
                                                            {loading ? "Signing up..." : "Sign up"}
                                                      </button> */}
                                                      {error && <div className="text-red-400 text-sm font-medium">{error}</div>}

                                                     <button
                                                      type="submit"
                                                      className="theme-btn-primary w-full px-5 py-2.5 text-center text-sm disabled:cursor-not-allowed disabled:opacity-70"
                                                      disabled={!termsChecked || loading}
                                                      
                                                      >
                                                      {loading ? "Signing up..." : "Sign up"}
                                                      </button>


                                                      {/* Login Link */}
                                                      <p className="text-sm text-center text-stone-300">
                                                            Already have an account?{" "}
                                                            <Link to="/login" className="font-medium text-amber-400 hover:underline">
                                                                  Sign in
                                                            </Link>
                                                      </p>
                                                </form>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>
                  <Footer />
            </>
      );
};

export default SignUp;
